import React from "react";
import "./Clients.css";

const clients = [
  { id: 1, img: "/assets/images/icons/client1.webp", name: "Client 1" },
  { id: 2, img: "/assets/images/icons/client2.jpg", name: "Client 2" },
  { id: 3, img: "/assets/images/icons/client3.png", name: "Client 3" },
  { id: 4, img: "/assets/images/icons/filsep-sml-logo.png", name: "Client 4" },
  { id: 5, img: "/assets/images/icons/nandi.png", name: "Client 5" },


  { id: 6, img: "/assets/images/icons/client4.webp", name: "Client 6" },
  { id: 7, img: "/assets/images/icons/client5.webp", name: "Client 7" },
  { id: 8, img: "/assets/images/icons/bharat-petroleum-vector-logo.png", name: "Client 8" },
  { id: 8, img: "/assets/images/icons/Aditya-Birla-Logo-Vector.svg-.png", name: "Client 9" },
  { id: 10, img: "/assets/images/icons/Logo-saudi-aramco-vector-PNG.avif", name: "Client 10" },
   { id: 11, img: "/assets/images/icons/marco.jpg", name: "Client 11" },
   { id: 12, img: "/assets/images/icons/Group 165.svg", name: "Client 12" },
];

const movingLogos = [...clients, ...clients, ...clients];

const Clients = () => {
  return (
    <section className="clients-section">
      <h2 className="clients-title">Client Highlights</h2>

      <div className="clients-marquee" aria-label="Client logos">
        <div className="clients-marquee-row">
          {movingLogos.map((client, index) => (
            <div className="client-logo-card" key={`${client.id}-${index}`}>
              <img src={client.img} alt={client.name} />
            </div>
          ))}
          </div>
      </div>
    </section>
  );
};

export default Clients;
